(function () {
    'use strict';

    angular.module('SMART2').service('gridConfigProvider', ['cellTemplateProvider', '$filter', 'formWidgetUtils', 'APPCONSTANTS', function (cellTemplateProvider, $filter, formWidgetUtils, APPCONSTANTS) {

        function getDefaultGridConfigObject() {
            return {
                "field": "",
                "displayName": "",
                "groupingShowAggregationMenu": false,
                "enableHiding": false,
                //"suppressRemoveSort": true,
                "groupingShowGroupingMenu": false,
                "enablePinning": false
            };
        }

        function getGridConfig(conf, scope, cellClassFunction, cellEditableConditionFunction) {
            var finalObject = _.extend(new getDefaultGridConfigObject(), conf);

            if (finalObject.isVisible != undefined) {
                finalObject.visible = formWidgetUtils.convertAndGetValue(finalObject.isVisible, scope, finalObject);
            }

            finalObject.enableCellEdit = true;

            if (finalObject.isReadOnly != undefined) {
                finalObject.enableCellEdit = !formWidgetUtils.convertAndGetValue(finalObject.isReadOnly, scope, finalObject);
            }

            if (finalObject.isFixed) {
                if (finalObject.isFixed == "Left")
                    finalObject.pinnedLeft = true;
                if (finalObject.isFixed == "Right")
                    finalObject.pinnedRight = true;
                finalObject.maxWidth = 260;
            }
            if (finalObject.isGrouped) {
                finalObject.grouping = {
                    "groupPriority": 0
                }
                //finalObject.sort = {
                //    "priority": 0,
                //    "direction": "asc"
                //}
            }
            if (finalObject.aggregation) {
                finalObject.treeAggregationType = 2;
            }

            finalObject.displayKey = finalObject.displayName;
            if (finalObject.isMandatory || finalObject.isRuleCheckManadatory) {
                finalObject.displayName = $filter('translate')(finalObject.displayName) + " *";
            } else {
                finalObject.displayName = $filter('translate')(finalObject.displayName);
            }


            if (finalObject.type) {
                switch (finalObject.type) {
                    case "popup":
                        finalObject.cellTemplate = cellTemplateProvider.getCellTemplate(finalObject, "cellTemplate");
                        finalObject.editableCellTemplate = cellTemplateProvider.getCellTemplate(finalObject, "editableCellTemplate");
                        break;
                    case "editable":
                        if (finalObject.attributes && finalObject.attributes.type == "date") {
                            finalObject.cellTemplate = cellTemplateProvider.getCellTemplate(finalObject, "cellTemplate");
                            finalObject.editableCellTemplate = cellTemplateProvider.getCellTemplate(finalObject, "editableCellTemplate");
                        }
                        if (finalObject.attributes && finalObject.attributes.type == "autocomplete") {
                            if (finalObject.cellTemplate == undefined || finalObject.cellTemplate == null) {
                                finalObject.cellTemplate = cellTemplateProvider.getCellTemplate(finalObject, "cellTemplate");
                            }
                            finalObject.editableCellTemplate = cellTemplateProvider.getCellTemplate(finalObject, "editableCellTemplate");
                        }
                        if (finalObject.attributes && finalObject.attributes.type == "number") {
                            finalObject.cellTemplate = cellTemplateProvider.getCellTemplate(finalObject, "cellTemplate");
                            finalObject.editableCellTemplate = cellTemplateProvider.getCellTemplate(finalObject, "editableCellTemplate");
                        }
                        if (finalObject.attributes && (finalObject.attributes.type == "text" || finalObject.attributes.type == undefined)) {
                            finalObject.cellTemplate = cellTemplateProvider.getCellTemplate(finalObject, "cellTemplate");
                            finalObject.editableCellTemplate = cellTemplateProvider.getCellTemplate(finalObject, "editableCellTemplate");
                        }
                        break;
                    case "dropdown":
                        if (!finalObject.attributes.idKey) {
                            finalObject.attributes.idKey = 'id'
                        }
                        finalObject.editableCellTemplate = cellTemplateProvider.getCellTemplate(finalObject, "editableCellTemplate");
                        finalObject.cellTemplate = cellTemplateProvider.getCellTemplate(finalObject, "cellTemplate");
                        break;
                    case "calculated":
                        finalObject.cellTemplate = cellTemplateProvider.getCellTemplate(finalObject);
                        if (finalObject.enableCellEdit) finalObject.enableCellEdit = false;
                        break;
                    case "checkbox":
                        finalObject.cellTemplate = cellTemplateProvider.getCellTemplate(finalObject, "cellTemplate");
                        break;
                };
                //if (finalObject.editableCellTemplate) {
                //finalObject.enableCellEdit = true;
                //};
            }

            finalObject.cellClass = cellClassFunction;
            finalObject.cellEditableCondition = cellEditableConditionFunction;

            if (finalObject.hasOwnProperty('filterObject')) {
                finalObject.enableFiltering = finalObject.filterObject.enableFiltering;
                if (finalObject.enableFiltering) {
                    finalObject.filter = {
                        placeholder: $filter('translate')("P2P_Common_Search")
                    }
                    if (finalObject.filterObject.hasOwnProperty('filterKeys')) {
                        finalObject.filter.condition = function (searchTerm, cellValue, row, col) {
                            var result = false;
                            if (typeof finalObject.filterObject.filterKeys != 'object' || typeof cellValue != 'object' || (typeof finalObject.filterObject.filterKeys == 'object' && finalObject.filterObject.filterKeys.length == 0)) {
                                result = true;
                            }
                            for (var key in cellValue) {
                                if (finalObject.filterObject.filterKeys.indexOf(key) > -1) {
                                    if (typeof cellValue[key] == 'string' && cellValue[key].toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) {
                                        result = true;
                                    }
                                }
                            }

                            var cellConditionResult = true;
                            if (angular.isDefined(finalObject.filterObject.cellCondition)) {
                                try {
                                    cellConditionResult = eval(finalObject.filterObject.cellCondition);
                                }
                                catch (e) { }
                            }

                            return result && cellConditionResult;
                        };
                    }
                    else if (finalObject.filterObject.isDate) {
                        finalObject.filter.condition = function (searchTerm, cellValue, row, col) {
                            var result = false;
                            if (searchTerm == undefined || searchTerm == null || (angular.isDefined(searchTerm) && searchTerm.trim() == "")) {
                                result = true;
                            }
                            if (angular.isDefined(searchTerm) && (cellValue == undefined || cellValue == null)) {
                                result = false;
                            }
                            if (angular.isDefined(searchTerm) && angular.isDefined(cellValue)) {
                                var formattedDate = (cellValue).replace(new RegExp("/", "ig"), '');
                                formattedDate = formattedDate.split('+');
                                formattedDate = eval('new ' + formattedDate[0] + (formattedDate.length > 1 ? ')' : ''));
                                var month = formattedDate.getMonth() + 1 + '';
                                if (month.length === 1) {
                                    month = 0 + '' + month;
                                }
                                formattedDate = formattedDate.getDate() + '/' + month + '/' + formattedDate.getFullYear();
                                result = formattedDate.toLowerCase().trim().indexOf(escape(searchTerm).replace(/%5C/g, '').trim()) > -1;

                                var cellConditionResult = true;
                                try {
                                    cellConditionResult = eval(finalObject.filterObject.cellCondition);
                                }
                                catch (e) { }

                                return result && cellConditionResult;
                            }
                        };
                    }
                    else if (finalObject.filterObject.hasOwnProperty('cellCondition')) {
                        finalObject.filter.condition = function (searchTerm, cellValue, row, col) {
                            var result = false;
                            if (cellValue && cellValue.toLocaleLowerCase().indexOf(searchTerm) > -1) {
                                result = true;
                            }
                            else {
                                result = false;
                            }
                            var cellConditionResult = true;
                            try {
                                cellConditionResult = eval(finalObject.filterObject.cellCondition);
                            }
                            catch (e) { }
                            return result && cellConditionResult;
                        };
                    }
                }
            }
            else {
                finalObject.enableFiltering = false;
            }

            finalObject.uiType = finalObject.type;
            delete finalObject.type;

            return finalObject;
        }

        this.getMassagedGirdConfig = function (confArr, scope, cellClassFunction, cellEditableConditionFunction) {
            var massagedConf = [];
            _.each(confArr, function (conf) {
                massagedConf.push(getGridConfig(conf, scope, cellClassFunction, cellEditableConditionFunction));
            });
            return massagedConf;
        };



        function getSmartTableConfig(conf, scope, cellClassFunction, cellEditableConditionFunction) {
            var finalObject = _.extend(new getDefaultGridConfigObject(), conf);

            if (finalObject.isVisible != undefined) {
                finalObject.visible = formWidgetUtils.convertAndGetValue(finalObject.isVisible, scope, finalObject);
            }

            finalObject.enableCellEdit = true;

            if (finalObject.isReadOnly != undefined) {
                finalObject.enableCellEdit = !formWidgetUtils.convertAndGetValue(finalObject.isReadOnly, scope, finalObject);
            }

            if (finalObject.isFixed) {
                if (finalObject.isFixed == "Left")
                    finalObject.pinnedLeft = true;
                if (finalObject.isFixed == "Right")
                    finalObject.pinnedRight = true;
                finalObject.maxWidth = 260;
            }
            if (finalObject.isGrouped) {
                finalObject.grouping = {
                    "groupPriority": 0
                }
                //finalObject.sort = {
                //    "priority": 0,
                //    "direction": "asc"
                //}
            }
            if (finalObject.aggregation) {
                finalObject.treeAggregationType = 2;
            }

            finalObject.displayKey = finalObject.displayName;
            if (finalObject.isMandatory  || finalObject.isRuleCheckManadatory) {
                if (APPCONSTANTS.userPreferences.DocumentTypeId == 7 || APPCONSTANTS.userPreferences.DocumentTypeId == 8) {
                    if (APPCONSTANTS.userPreferences.DocumentTypeId == 8)
                        finalObject.displayName = $filter('translate')(finalObject.displayName);

                    finalObject.headerCellTemplate = function (colDef) {
                        return "<span title=\"" + $filter('translate')(colDef.displayName) + "*\">" + $filter('translate')(colDef.displayName) + "<span class=\"mandatoryAsterisk\">*</span></span>";
                    }
                }
                else {
                    finalObject.displayName = $filter('translate')(finalObject.displayName) + (APPCONSTANTS.userPreferences.DocumentTypeId == 8 ? "*" : " *");
                }
            }
            else {
                finalObject.displayName = $filter('translate')(finalObject.displayName);
            }


            if (finalObject.field) {
                if (finalObject.field == 'InvoiceTotalQuantity' || finalObject.field == 'InvoiceTotalAmount') {
                    finalObject.headerCellTemplate = function (colDef) {
                        return "<span>" + $filter('translate')(colDef.displayName) + "<i class=\"icon small catpopup-title\" title=\"" + $filter('translate')('P2P_PO_InvoiceQuantityAmount_Itext') + "\" style=\"vertical-align: top;height: 17px;\"><svg style=\"vertical-align: top;height: 17px;width: 17px;\"><use style=\"vertical-align: top;\" href=\"#icon_Info\"></use></svg></i></span>";
                    }
                }
            }

            if (finalObject.field) {
                if (finalObject.field == 'ConversionFactor') {
                    finalObject.headerCellTemplate = function (colDef) {                       
                        return "<span title=\"" + $filter('translate')(colDef.displayName) + "\">" + $filter('translate')(colDef.displayName) + " (" + (APPCONSTANTS.BaseCurrency == undefined ? '' : APPCONSTANTS.BaseCurrency) + ")" + "</span>";
                    }
                }
			}
			if (finalObject.field) {
				if (finalObject.field == 'LineBaseCurrencyTotal') {
					finalObject.headerCellTemplate = function (colDef) {
						return "<span title=\"" + $filter('translate')(colDef.displayName) + "\">" + $filter('translate')(colDef.displayName) + " (" + (APPCONSTANTS.BaseCurrency == undefined ? '' : APPCONSTANTS.BaseCurrency) + ")" + "</span>";
					}
				}
			}


            if (finalObject.type) {
                switch (finalObject.type) {
                    case "dropdown":
                        if (!finalObject.attributes.idKey) {
                            finalObject.attributes.idKey = 'id'
                        }
                        break;

                    case "calculated":
                        finalObject.cellTemplate = function (row, column) {
                            if (column.colDef.field && column.colDef.field != 'IsCloseForReceiving' && column.colDef.field != 'IsCloseForInvoicing' && column.colDef.field != 'FulfillmentDocumentType') {
                                return $filter('minPrecisionHandler')(eval(column.colDef.attributes.rule), column.colDef.attributes.minmaxprecisionfilter.split(':')[0], column.colDef.attributes.minmaxprecisionfilter.split(':')[1], false);
                            }
                            else {
                                return eval(column.colDef.attributes.rule);
                            }
                        };
                        finalObject.enableCellEdit = false;
                        break;

                    case 'popup':
                        switch (finalObject.attributes.type) {
                            case 'splitsPopup':
                                finalObject.cellTemplate = function (row, column) {
                                    if (row.entity.type != undefined || row.entity.type != null) {
                                        return row.entity.splitType == 0 ? (row.entity.type.id == 1 ? $filter('translate')('P2P_Common_Quantity') : $filter('translate')('P2P_Common_Amount')) : $filter('translate')('P2P_Common_Percentage');
                                    }
                                    else {
                                        return $filter('translate')('P2P_Common_Percentage');
                                    }
                                };
                                break;
                            case 'requisitionLink':
                                finalObject.cellTemplate = function (row, column) {
                                    return (row.entity.RequisitionNumber != null && row.entity.RequisitionNumber.length > 0) ? row.entity.RequisitionNumber : '';
                                };
                                break;
                            case 'commentsAndAttachmentsPopup':
                                finalObject.cellTemplate = function (row, column) {
                                    var commentObj;
                                    if (!row.entity.isSupplier) {
                                        return row.entity.notes && row.entity.notes.length > 0 ? $filter('translate')('P2P_Common_View') : $filter('translate')('P2P_Common_Add');
                                    }
                                    else {
                                        if (row.entity.notes && row.entity.notes.length == 0)
                                            return $filter('translate')('P2P_Common_Add');
                                        else {
                                            if (row.entity.notes) {
                                                for (var i = 0; i < row.entity.notes.length; i++) {
                                                    if (row.entity.notes[i].accessType && (row.entity.notes[i].accessType.id == 4 || row.entity.notes[i].accessType.name === "P2P_InternalUsersAndSuppliers"))
                                                        return commentObj =  $filter('translate')('P2P_Common_View');
                                                    else
                                                        commentObj =  $filter('translate')('P2P_Common_Add');
                                                }
                                                return commentObj;
                                            }
                                            else
                                                return  $filter('translate')('P2P_Common_Add');
                                        }
                                    }
                                };
                                break;
                            case 'multiselectPopUp':
                                finalObject.cellTemplate = function (row, column) {
                                    var key = column.colDef.attributes.model;
                                    if (!Array.isArray(row.entity[key])) {
                                        var obj = row.entity[key];
                                        row.entity[key] = [];
                                        row.entity[key].push(obj);
                                    }
                                    var objects = _.filter(row.entity[key], function (item) { return item.AdditionalFieldCode != ""; });
                                    if (objects.length > 0) {
                                        return $filter('translate')('P2P_Common_View');
                                    }
                                    else return $filter('translate')('P2P_Common_Add');
                                };
                                finalObject.enableCellEdit = true;
                                break;
                            case 'customAttributesPopup':
                            case 'fulfilmentDocumentDetailsPopup':
                                if (APPCONSTANTS.userPreferences.DocumentTypeId == 7) {
                                    console.log(scope.$parent.$parent.formModel.ReqData);
                                    var AllowEditofCustAttrbyApproveronSubmittedReqs = _.filter(APPCONSTANTS.userPreferences.DocumentSettings.lstSettings, { FieldName: "AllowEditofCustAttrbyApproveronSubmittedReqs" });
                                    var IsAllowEditofCustAttr = AllowEditofCustAttrbyApproveronSubmittedReqs && AllowEditofCustAttrbyApproveronSubmittedReqs.length > 0 ? AllowEditofCustAttrbyApproveronSubmittedReqs[0].FieldValue.toLowerCase() == "true" : false;

                                    if (
                                        (scope.$parent.$parent.formModel.ReqData.status.id == APPCONSTANTS.docStateConstants.Draft) ||
                                        ((scope.$parent.$parent.formModel.ReqData.IsCustomAttributesLineReadOnly == false) &&
                                            (scope.$parent.$parent.formModel.ReqData.status.id == APPCONSTANTS.docStateConstants.ReviewPending) ||
                                            (scope.$parent.$parent.formModel.ReqData.status.id == APPCONSTANTS.docStateConstants.Withdrawn) ||
                                            (scope.$parent.$parent.formModel.ReqData.status.id == APPCONSTANTS.docStateConstants.Rejected) ||
                                            (scope.$parent.$parent.formModel.ReqData.status.id == APPCONSTANTS.docStateConstants.ApprovalPending && IsAllowEditofCustAttr == true))) {
                                        finalObject.cellTemplate = function (row, column) {
                                            var count = 0;
                                            if (scope.$parent.$parent.formModel.ReqData.status.id == APPCONSTANTS.docStateConstants.Draft && row.entity.IsAddedFromRequistion && row.entity.IsAddedFromRequistion == true)
                                                return $filter('translate')('P2P_Common_View');

                                            else if (row.entity && row.entity.ItemCustomAttribs && row.entity.ItemCustomAttribs.length > 0)
                                                count = CustomAttributeCheck(row.entity.ItemCustomAttribs);

                                            else if (row.entity && row.entity.ListQuestionResponse && row.entity.ListQuestionResponse.length > 0)
                                                count = CustomAttributeCheck(row.entity.ListQuestionResponse);

                                            if (count > 0)
                                                return $filter('translate')('P2P_Common_Edit');
                                            else
                                                return $filter('translate')('P2P_Common_Add');
                                        }
                                    }
                                    else {
                                        finalObject.placeHolder = $filter('translate')('P2P_Common_View');
                                        break;
                                    }

                                }
                                else
                                    finalObject.placeHolder = $filter('translate')('P2P_Common_View');
                                break;

                            case 'manufacturerPopup':
                                finalObject.cellTemplate = function (row, column) {
                                    if (row.entity.manufacturer || row.entity.manufacturerPartNumber || row.entity.ManufacturerModel) {
                                        row.entity.manufacturerName = row.entity.manufacturer + ":" + row.entity.manufacturerPartNumber + ":" + row.entity.ManufacturerModel;
                                    }
                                    return row.entity.manufacturerName ? (row.entity.manufacturerName) : $filter('translate')('P2P_Common_Add');
                                };
                                break;

                            case 'categoryPopup':
                                finalObject.debounce = 250;
                                break;
                            case 'linkToOrderPopup':
                                finalObject.cellTemplate = function (row, column) {
                                    return $filter('translate')('P2P_Common_View');
                                };
                                break;

                            case 'taxesPopup':
                                finalObject.cellTemplate = function (row, column) {
                                    return row.entity.isTaxExempt ? $filter('translate')('P2P_Common_Exempt') : (APPCONSTANTS.userPreferences.DocumentTypeId == 38 ? 'Taxable' : row.entity.taxes);
                                };
                                break;
			    case 'blanketDetailsPopup':
                                finalObject.cellTemplate = function (row, column) {
                                    return $filter('translate')('P2P_Common_View');
                                };
                            break;
                          case 'multipleSelectPopup':
                            finalObject.cellTemplate = function (row, column) {
                              if (row.entity.lstAdditionalFieldAttributues && row.entity.lstAdditionalFieldAttributues.length > 0) {
                                var fieldIndex = _.findIndex(row.entity.lstAdditionalFieldAttributues, { AdditionalFieldID: column.colDef.attributes.AdditionalFieldId });
                                if (fieldIndex >= 0) {
                                  var key = column.colDef.attributes.model;
                                  if (row.entity[key] && row.entity[key].code)
                                    return $filter('translate')('P2P_Common_View');
                                  else
                                    return $filter('translate')('P2P_Common_Add');
                                }
                                else
                                  return $filter('translate')('P2P_Common_Add');
                              }
                            else{
                               return $filter('translate')('P2P_Common_Add');
                            }
                            };
                            break;
                        }
                        break;
                    case 'editable':
                        if (APPCONSTANTS.userPreferences.DocumentTypeId == 8) {
                            switch (finalObject.data) {
                                case 'category.name':
                                    finalObject.cellTemplate = function (row, column) {
										column.colDef.showTooltip = true;
										column.colDef.tooltip = (row.entity.CategoryHierarchy == undefined || row.entity.CategoryHierarchy == '') ? 'category.name' : 'CategoryHierarchy';
                                        return  row.entity.category.name ;
                                    };
                                    break;
                            }
                        }
                        break;
                };
            }

            finalObject.cellClass = cellClassFunction;
            finalObject.cellEditableCondition = cellEditableConditionFunction;

            if (finalObject.hasOwnProperty('filterObject')) {
                finalObject.enableFiltering = finalObject.filterObject.enableFiltering;
                if (finalObject.enableFiltering) {
                    finalObject.filter = {
                        placeholder: $filter('translate')("P2P_Common_Search")
                    }
                    if (finalObject.field == 'IsCloseForReceiving' || finalObject.field == 'IsCloseForInvoicing') {
                        finalObject.filter.condition = function (searchTerm, row, col) {
                            var result = false;
                            var tempCellVal = row[col.field].toString().toLowerCase() == 'true' ? 'closed' : 'open';

                            if (tempCellVal.indexOf(searchTerm.toLowerCase()) > -1) {
                                result = true;
                            }
                            return result;
                        }
                    }
                    if (finalObject.field == 'FulfillmentDocumentType') {
                        finalObject.filter.condition = function (searchTerm, row, col) {
                            var result = false;
                            var tempCellVal = '';
                            if (row[col.field] == 31) {
                                tempCellVal = 'service confirmation';
                            } else if (row[col.field] == 10) {
                                tempCellVal = 'receipt';
                            } else if (row[col.field] == 39) {
                                tempCellVal = 'timesheet';
                            } 

                            if (tempCellVal.indexOf(searchTerm.toLowerCase()) > -1) {
                                result = true;
                            }
                            return result;
                        }
                    }
                    if (finalObject.attributes.filterkeys && finalObject.attributes.filterkeys.indexOf("entityCode") > -1) {
                        finalObject.filter.condition = function (searchTerm, row, col) {
                            var result = false;
                            if (((row[col.field.split('.')[0]].entityCode + '-' + row[col.field.split('.')[0]].name).toLowerCase()).indexOf(searchTerm.toLowerCase()) > -1) {
                                result = true;
                            }
                            return result;
                        }
                    }
                    if (finalObject.filterObject.hasOwnProperty('filterKeys')) {
                        finalObject.filter.condition = function (searchTerm, cellValue, row, col) {
                            var result = false;
                            if (typeof finalObject.filterObject.filterKeys != 'object' || typeof cellValue != 'object' || (typeof finalObject.filterObject.filterKeys == 'object' && finalObject.filterObject.filterKeys.length == 0)) {
                                result = true;
                            }
                            for (var key in cellValue) {
                                if (finalObject.filterObject.filterKeys.indexOf(key) > -1) {
                                    if (typeof cellValue[key] == 'string' && cellValue[key].toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) {
                                        result = true;
                                    }
                                }
                            }

                            var cellConditionResult = true;
                            if (angular.isDefined(finalObject.filterObject.cellCondition)) {
                                try {
                                    cellConditionResult = eval(finalObject.filterObject.cellCondition);
                                }
                                catch (e) { }
                            }

                            return result && cellConditionResult;
                        };
                    }
                    else if (finalObject.filterObject.isDate) {
                        finalObject.filter.condition = function (searchTerm, cellValue, row, col) {
                            var result = false;
                            if (searchTerm == undefined || searchTerm == null || (angular.isDefined(searchTerm) && searchTerm.trim() == "")) {
                                result = true;
                            }
                            if (angular.isDefined(searchTerm) && (cellValue == undefined || cellValue == null)) {
                                result = false;
                            }
                            if (angular.isDefined(searchTerm) && angular.isDefined(cellValue)) {
                                var formattedDate = (cellValue).replace(new RegExp("/", "ig"), '');
                                formattedDate = formattedDate.split('+');
                                formattedDate = eval('new ' + formattedDate[0] + (formattedDate.length > 1 ? ')' : ''));
                                var month = formattedDate.getMonth() + 1 + '';
                                if (month.length === 1) {
                                    month = 0 + '' + month;
                                }
                                formattedDate = formattedDate.getDate() + '/' + month + '/' + formattedDate.getFullYear();
                                result = formattedDate.toLowerCase().trim().indexOf(escape(searchTerm).replace(/%5C/g, '').trim()) > -1;

                                var cellConditionResult = true;
                                try {
                                    cellConditionResult = eval(finalObject.filterObject.cellCondition);
                                }
                                catch (e) { }

                                return result && cellConditionResult;
                            }
                        };
                    }
                    else if (finalObject.filterObject.hasOwnProperty('cellCondition')) {
                        finalObject.filter.condition = function (searchTerm, cellValue, row, col) {
                            var result = false;
                            if (cellValue && cellValue.toLocaleLowerCase().indexOf(searchTerm) > -1) {
                                result = true;
                            }
                            else {
                                result = false;
                            }
                            var cellConditionResult = true;
                            try {
                                cellConditionResult = eval(finalObject.filterObject.cellCondition);
                            }
                            catch (e) { }
                            return result && cellConditionResult;
                        };
                    }
                }

                //  filter condition for split type column
                if (finalObject.attributes.type == 'splitsPopup') {
                    finalObject.filter.condition = function (searchTerm, row, col) {
                        return (row.splitType == 0 ? (row.type.id == 1 ? 'Quantity' : 'Amount') : 'Percentage').toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
                    };
                }
            }
            else {
                finalObject.enableFiltering = false;
            }

            switch (finalObject.field) {
                case 'total':
                    finalObject.sortCondition = function (data, column, isAscending) {
                        if (angular.isDefined(column.attributes.rule)) {
                            return data.sort(function (a, b) {
                                a = eval(column.attributes.rule.replace(/row.entity/g, 'a'));
                                b = eval(column.attributes.rule.replace(/row.entity/g, 'b'));
                                return a > b ? (isAscending ? -1 : 1) : (a < b ? (isAscending ? 1 : -1) : 0);
                            });
                        }
                        return data;
                    };
                    break;
            }

            finalObject.uiType = finalObject.type;
            delete finalObject.type;

            return finalObject;
        };

        function CustomAttributeCheck(ItemCustomAttribs) {
            var count = 0;
            for (var i = 0; i < ItemCustomAttribs.length; i++) {
                if ((ItemCustomAttribs[i].ResponseValue && ItemCustomAttribs[i].ResponseValue != null) || (ItemCustomAttribs[i].QuestionResponse && ItemCustomAttribs[i].QuestionResponse != null)) {
                    count++;
                    return count;
                }
            }
        }

        this.getMassagedSmartTableConfig = function (confArr, scope, cellClassFunction, cellEditableConditionFunction) {
            var massagedConf = [];
            _.each(confArr, function (conf) {
                massagedConf.push(getSmartTableConfig(conf, scope, cellClassFunction, cellEditableConditionFunction));
            });
            return massagedConf;
        };

        this.eavluateScopeBindedExpressions = function (val, scope, obj) {
            return formWidgetUtils.convertAndGetValue(val, scope, obj)
        };
    }]);
})();
